import { render, staticRenderFns } from "./AptitudeTestPage.vue?vue&type=template&id=9cbdb11e&"
import script from "./AptitudeTestPage.vue?vue&type=script&lang=js&"
export * from "./AptitudeTestPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports